<div class="forgot_details_card mat-elevation-z4">
    <div style="float: right;"><button (click)="closeDialog()" style="background-color: white;border: none;font-size: 20px;font-weight: 500;">X</button></div>
    <div class="forgot_details_code_card">
        <div class="forgot_details_header">Verification Code</div>
        <div class="forgot_details_header_details">Enter the code sent to your {{data.type}}</div>
        <div style="text-align: center;">
            <div class="code_inputs">
                <input type="text" maxlength="1" [(ngModel)]="code[0]" (keyup)="focusNext($event, 1)">
                <input type="text" maxlength="1" [(ngModel)]="code[1]" (keyup)="focusNext($event, 2)">
                <input type="text" maxlength="1" [(ngModel)]="code[2]" (keyup)="focusNext($event, 3)">
                <input type="text" maxlength="1" [(ngModel)]="code[3]" (keyup)="focusNext($event, 4)">
            </div>
            <button class="forgot_button_details" (click)="verifyCode()">Verify</button>
        </div>
        <div style="text-align: center;padding: 15px 0px;color: var(--black-shade);font-family: var(--font);padding-bottom: 10px;font-size: 16px;">
            Didn't receive a code? <a href="#" class="resend_code">Resend code</a>
        </div>
    </div>
</div>